import React, { useState, useEffect } from 'react';
import './Usuarios.css'
import Header from '../Header/Header'
import UsuariosData from '../../Components/Admin/UsuariosData/UsuariosData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { fetchUsuario, getUsuario } from '../../Components/user';
export default function Usuarios() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario(); // Llama a la función para obtener datos del usuario
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();
    return (
        <div className='containerGrid'>
            <Header />



            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario ? (
                        <>
                            {usuarioLegued?.rol === 'admin' ? (
                                <UsuariosData />
                            ) : usuarioLegued?.rol === 'colaborador' ? (
                                <UsuariosData />
                            ) : (
                                <UsuariosData />
                            )}
                        </>
                    ) : (
                        <UsuariosData />
                    )}
                </div>
            </section>
        </div>
    )
}
